import styled from 'styled-components';

export const IconSpan = styled.span`
  display: flex;
`;
